export type RecallID = string;

export enum RECALL_ENTITY_STATUSSES {
  Unsupported = 1,
  Unsettled = 2,
  Settled = 3
}

export interface RecallEntity {
  id: RecallID; // Identifier of the recall
  campaign_code: string | null; // Identifier of the campaign (group of recalls)
  campaign_name: string; // Name of the campaign (group of recalls)
  start_date: string | null; // From when the recall is active
  close_date: string | null; // Till when the recall is active
  vin: string | null; // Vehicle Identification Number
  status: RECALL_ENTITY_STATUSSES; // Status of the recall. It can be Unsupported, Unsettled or Settled
}
